import React, { useState, useEffect } from 'react'

import Header from '../partials/Header'
import QrCodePhysician from '../partials/QrCodePhysician'
import OcularNotes from './OcularNotes'


export default function Choice1(props) {

  let instructionStyle = {
    fontSize: '24px',
    // textAlign: 'center',
    margin: "0 0 60px 0",
    width: '400px',
  }

  let mdInstructionStyle = {
    fontSize: '24px',
    textAlign: 'center',
    margin: "20px 0 -20px 0",
    width: '400px',
  }
  
  let headerStyle = {
    fontSize: '24px',
  }

  let rowDivStyle = {
    display: 'flex',
    margin: '10px 0 60px 0',
  }

  let imgDivStyle = {
    width: '240px', 
    display: 'flex', 
    justifyContent: 'start',
  }

  let column1Style = {
    margin: '10px', 
    fontSize: '20px', 
  }
  let column2Style = {
    margin: '10px', 
    fontSize: '16px', 
    textAlign:'center'
  }
  let column3Style = {
    margin: '3px', 
    fontSize: '16px', 
  }
  let cellStyle = {
    height: '200px'
  }

  let p1Style = {
    fontSize: '24px',
    margin: '0',
  }
  let p2Style = {
    fontSize: '16px',
    margin: '0',
  }

  let olStyle = {
    margin: '0',
  }


    return (
      <> 
        <div style={{
          maxWidth: '800px',
          width: '86vw',
        }}>
          {props.ptName
            ? <p style={{
              margin: '3px 30px 0 0',
              fontSize: '14px',
            }}>Name: {props.ptName}</p>
            : null
          }
          {props.ptDob
            ? <p style={{
              margin: '3px 30px 0 0',
              fontSize: '14px',
            }}>DOB: {props.ptDob}</p>
            : null
          }
          <p style={{
              margin: '3px 30px 0 0',
              fontSize: '14px',
            }}>{props.side} eye</p>
          {/* <p style={{margin: '10px 30px 0 0'}}>Lens: {props.lensModel}</p> */}
        </div>
        <Header
          title={"QR code for clinic"}
          subtitle={""}
        />
        <div style={{display: 'flex'}}>
          <div style={{width: '7vw'}}></div>
          <div style={{width: '84vw',}}>
            <p style={headerStyle}>On day of preop with surgeon (before patient meets with surgeon), Tech asks patient: 
              <span style={{fontSize: '24px', fontWeight: '600', margin: '0 0 0 7px'}}>
                "Did you use the QR code to explore your cataract vision options"
              </span>  
            </p>
            
       
            <div style={{maxWidth: '800px', display: 'flex'}}>
              <div style={column1Style}>
                <div style={cellStyle}>
                  <p style={p1Style}>
                    No
                  </p>
                  <p style={p2Style}>
                    Patient did NOT explore vision options
                  </p>  
                </div>
                <div style={cellStyle}>
                  <p style={p1Style}>
                    Yes
                  </p>
                  <p style={p2Style}>
                    Patient DID explore vision options
                  </p>  
                </div>
              </div>
              <div style={column2Style}>
                <div style={cellStyle}>
                   <QrCodePhysician //for Patient
                    linkTo='qr'
                    qrToken={props.qrToken}  
                    cipherText={props.cipherTextPt}    //cipherTextPt has 'qrpt' appended as usertype
                    encryptionKey={props.encryptionKey}
                  />  
                </div>
                <div style={cellStyle}>
                  <QrCodePhysician //for Doctor
                    linkTo='qr'
                    encryptionKey={props.encryptionKey}
                    setEncryptionKey={props.setEncryptionKey}
                    cipherText={props.cipherTextMd}  //cipherTextMd has 'qrmd' appended as usertype
                    qrToken={props.qrToken}
                    setQrToken={props.setQrToken}
                  />
                </div>
              </div>
              <div style={column3Style}>
                <div style={cellStyle}>
                  <ol style={olStyle}>
                    <li>
                      Scan this patient QR code with tablet
                    </li>
                    <li>
                      Set patient up with tablet (and or headphones) somewhere they can watch the video and explore options on their own
                    </li>
                    <li>
                      When patient is done, move them to an exam room and put the tablet and this paper in room for doctor
                    </li>
                  </ol>
                </div>
                <div style={cellStyle}>
                  <ol style={olStyle}>
                    <li>
                      Scan this doctor QR code for doctor when in room with patient
                    </li>
                    <li>
                       This QR allows the doctor to discuss vision options, make any edits to measurements, and sign paperwork
                    </li>
                  </ol>
                </div>
              </div>    
            </div>              
          </div>
          <div style={{width: '7vw'}}></div>    
        </div>
          

        <div style={{display: 'flex'}}>
          <div style={{width: '7vw'}}></div>
          <div style={{width: '84vw'}}>
            <hr/>
            <p
              style={{
                textAlign: 'center',
                fontSize: "24px",
                margin: '20px 0 0 0',
              }}
            >
              Surgical considerations
            </p>
            <div
              style={{
                display:'flex',
                justifyContent: 'center',
                width: '800px',
              }}
            >
              <OcularNotes
                power={props.power.toLowerCase().replace(/\s+/gm,'')}
                cylinder={props.cylinder.toLowerCase().replace(/\s+/gm,'')}
                axis={props.axis}
                add={props.add}
                codeStatus={props.codeStatus}
                allergies={props.allergies}
                side={props.side}
                bcva={props.bcva}
                ns={props.ns}
                bat={props.bat}
                equipmentPreference={props.equipmentPreference}
                biometer={props.biometer}
                biometerAstig={props.biometerAstig}
                biometerAxis={props.biometerAxis}
                chordMuTotal={props.chordMuTotal}
                topographer={props.topographer}
                topographerAstig={props.topographerAstig}
                topographerAxis={props.topographerAxis}
                topographerSphAb={props.topographerSphAb}
                topographerHoa={props.topographerHoa}
                lensOption={props.lensOption}
                lensModel={props.lensModel}
                lensLocation={props.lensLocation}
                sulcusLens={props.sulcusLens}
                contraindications={props.contraindications}

                lensCorrectsIntermediateVision={props.lensCorrectsIntermediateVision}
                lensCorrectsNearVision={props.lensCorrectsNearVision}
                lensTargetNear={props.lensTargetNear}
                lensKAstigMin={props.lensKAstigMin}
                cri={props.cri}
                flacs={props.flacs}

                cataractAddOn={props.cataractAddOn}
              />
            </div>
          </div>
        <div style={{width: '7vw'}}></div>   
      </div>



        <div>
          <div
            style ={{
              pageBreakBefore: 'always'}}
              >
          </div>
          <div style={{
              height: '150px',
              borderBottom: '1px dashed gray',
              margin: '0 0 40px 0',
            }}
            className = 'dontPrint'
            >
          </div>
        </div>


        <div style={{
          maxWidth: '800px',
          width: '86vw',
        }}>
          {props.ptName
            ? <p style={{
              margin: '3px 30px 0 0',
              fontSize: '14px',
            }}>Name: {props.ptName}</p>
            : null
          }
          {props.ptDob
            ? <p style={{
              margin: '3px 30px 0 0',
              fontSize: '14px',
            }}>DOB: {props.ptDob}</p>
            : null
          }
          <p style={{
              margin: '3px 30px 0 0',
              fontSize: '14px',
            }}>{props.side} eye</p>
          {/* <p style={{margin: '10px 30px 0 0'}}>Lens: {props.lensModel}</p> */}
        </div>
        <Header
          title={"QR code for patient"}
          subtitle={""}
        />
        <div style={{display: 'flex'}}>
          <div style={{width: '7vw'}}></div>
          <div style={{width: '84vw'}}>
            <div
              style={{
                width: '800px',
              }}
            >
              <div
                style={{
                  display:'flex',
                  justifyContent: 'center',
                }}
              >
                <QrCodePhysician
                  linkTo='qr'
                  qrToken={props.qrToken}  
                  cipherText={props.cipherTextPt}    //cipherTextPt has 'qrpt' appended as usertype
                  encryptionKey={props.encryptionKey}
                />  
              </div>
              
              <div
                style={{
                  display:'flex',
                  justifyContent: 'center',
                  width: '800px',
                  margin: '20px 0 0 0',
                }}
              >
                <div>
                  <div style={rowDivStyle}>
                    <div style={imgDivStyle}>
                      <img
                        src='ipadScan.jpg'
                        alt='ipad scan'
                        height='140px'
                      />
                    </div>
                    <p style={instructionStyle}>
                      1: Use your iPad camera app to scan the QR code above
                    </p>
                  </div>
                  <div style={rowDivStyle}>
                    <div style={imgDivStyle}>
                      <img
                        src='ipadLink.jpg'
                        alt='ipad link'
                        height='140px'
                      />
                    </div>
                    <p style={instructionStyle}>
                      2: Click on the link
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{width: '7vw'}}></div>    
          
        </div>
          
      </>
    );
  }
